import React,{Component} from 'react'
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import {Card} from '../../../../components/index.component';

class TourSlider extends Component {
    constructor (props) {
        super (props);
        this.slider = null;
        this.handleNext = this.handleNext.bind(this);
    }

    _renderTours(){
            return this.props.tours.map((val)=> {
                return (
                    <div>
                        <Card className={this.props.className} data={val}/>
                    </div>
                )
            })
    }

    handleNext() {
        if (this.slider) {
            this.slider.slickNext();
        }
    }

    handlePrev() {
        if (this.slider) {
            this.slider.slickPrev();
        }
    }

    render(){
        const settings = {
            dots: false,
            infinite: true,
            nav: false,
            accessibility: false,
            arrows: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            touchThreshold: 10
        }
        return(
            <div>
                <Slider ref={c => { this.slider = c; }} {...settings}>
                    {this._renderTours()}
                </Slider>
            </div>
        )
    }
}

export default TourSlider